import { useQuery } from '@tanstack/react-query';
import { getInstalledMcps, USER_MCP_QUERY_KEYS } from '../../api';

export const useInstalledMcps = (enabled = true) =>
  useQuery({
    queryKey: USER_MCP_QUERY_KEYS.installed,
    queryFn: getInstalledMcps,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
